import src from "IMAGE";
export default { src, width: 103, height: 18, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AF7Dkf9DoXPaWriK8Eqqe+RLq3zkWbiJ8EWidNq22Mz/Pd8UMPBu2uEAAAAASUVORK5CYII="};
